import React from "react";
import useCurrency from "../../../../../hooks/useCurrency";

import {

    Button,
    Card,
    Space,
    Tag,
    Typography

} from "antd";

import {

    ShoppingCartOutlined

} from "@ant-design/icons";

const { Title, Text } = Typography;

const OrderNotificationCard = ({

                                   notification,

                                   onOpenOrder

                               }) => {

    const { symbol } = useCurrency();

    return (

        <Card

            hoverable

            style={{

                marginBottom:15,

                borderRadius:12

            }}

        >

            <Space

                direction="vertical"

                style={{

                    width:"100%"

                }}

            >

                <Title level={5}>

                    <ShoppingCartOutlined />

                    {" "}

                    Nouvelle commande

                </Title>

                <Text>

                    {notification.productName}

                </Text>

                <Text>

                    Quantité :

                    {" "}

                    {notification.quantity}

                </Text>

                <Text>

                    Montant :

                    {" "}

                    {notification.totalAmount}

                    {symbol(notification.currency)}

                </Text>

                <Tag color="green">

                    {notification.status}

                </Tag>

                <Button

                    type="primary"

                    onClick={()=>

                        onOpenOrder(

                            notification

                        )

                    }

                >

                    Voir commande

                </Button>

            </Space>

        </Card>

    );

};

export default OrderNotificationCard;